export default __webpack_public_path__ + "static/media/ref_expression.59eb87d8.png";